import { DropdownOption } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getSpecializationPrograms: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<DropdownOption<string>[]> = (fetchContext, accessToken) => fetch(`${fetchContext.baseUrl}/api/admin/specialization-programs`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<DropdownOption<string>[]>(fetchContext.errorStore, response, 'get specialization programs'));
